import React from 'react';
import { TablePagination } from 'drift-ui';
import { useSearchQueryParams } from '../../../utils/hooks';
import { getPageOptions } from '../../../services/usersService/usersServiceQuery';

type Props = {
  onRowsPerPageChange: (page: number) => void;
  onPageChange: (page: number) => void;
  totalItems: number;
};

const Pagination = ({ totalItems, onRowsPerPageChange, onPageChange }: Props) => {
  const { getQueryParam } = useSearchQueryParams();
  const currentPage = parseInt(getQueryParam('page') ?? '1');
  const rowsPerPageQuery = parseInt(getQueryParam('perPage') ?? '10');
  const defaultRows = !getPageOptions().includes(rowsPerPageQuery) && getPageOptions()[0];
  const rowsPerPage = defaultRows || rowsPerPageQuery;

  return (
    <TablePagination
      page={currentPage - 1}
      rowsPerPage={rowsPerPage}
      count={totalItems}
      rowsPerPageOptions={getPageOptions()}
      onPageChange={(_event, page) => {
        onPageChange(page + 1);
      }}
      onRowsPerPageChange={(event) => {
        onRowsPerPageChange(Number.parseInt(event.target.value, 10));
      }}
    />
  );
};

export default Pagination;
